import React from "react";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import {
  BackBtn
} from "./styles";
import { blue, indigo } from "@mui/material/colors";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';

const BackButton = ({...props}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1)
  };

  return (
    <BackBtn onClick={handleGoBack} userPanel={props.userPanel} >
      <KeyboardArrowLeftIcon
        fontSize="large"
        sx={{ color: props.userPanel ? indigo[900] : blue[50] }}
        /> {t('back')}
    </BackBtn>
  );
};

export default BackButton;
